import { Form, Modal } from "antd";
import React from "react";
import { CreateCarbonMobileSourceDto } from "../../../../api";
import { CarbonMobileSourceColumns } from "../form/columns";

interface CarbonMobileSourceFormProps {
  visible: boolean;
  setVisible: Function;
  onCreateCarbonMobileSource: (values: CreateCarbonMobileSourceDto) => void;
}

export const CarbonMobileSourceForm: React.FC<CarbonMobileSourceFormProps> = ({ visible, setVisible, onCreateCarbonMobileSource }) => {
  const [form] = Form.useForm<CreateCarbonMobileSourceDto>();

  return (
    <Modal open={visible} onOk={form.submit} okText="Создать" cancelText="Отмена" onCancel={() => setVisible(false)}>
      <Form form={form} className="p-8" layout="vertical" onFinish={onCreateCarbonMobileSource}>
        {CarbonMobileSourceColumns().map(({ title, key, rules, inputNode, hideOnForm }, index) => (
          <>
            {!hideOnForm && <Form.Item label={title} name={key} rules={rules} key={index}>
              {inputNode}
            </Form.Item>}
          </>
        ))}
      </Form>
    </Modal>
  );
};
